"use strict";function shareImage$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.shareImage$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.util.shareImage";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"4.1"},_a[ddSdk_1.ENV_ENUM.android]={vs:"4.1"},_a)),exports.shareImage$=shareImage$,exports.default=shareImage$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/util/shareImage.js
// module id = 1028
// module chunks = 106